import search from './search'
import entities from './entities'

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: require('@/views/Admin/Landing.vue').default
  },

  {
    path: '/development-progress',
    name: 'Development Progress',
    component: require('@/views/Development/Progress.vue').default
  },

  ...search,
  ...entities
]

export default routes
